import React, { useEffect, useMemo, useState } from "react";
import { EuiFlexItem,EuiPopover,EuiButtonIcon,EuiLoadingSpinner,EuiText } from "@elastic/eui";
import { useNotifications } from "../../hooks/Notifications";
import { AdjuntosAdapter } from "../../../infraestructure/persistence/rest/AdjuntosAdapter";
import { ServerErrorMessage } from "../../utils/error";
import {ListaAdjuntosContainer as ListadoAdjuntos} from '../../../ui/src/components/Listas/Adjuntos/container';
import { downloadFile } from "../../utils/download";
import { useToasts } from "react-toast-notifications";
import { Notification } from '../../../shared/components/Notifications/interface';

export const AdjuntosCellRenderer = (params:any, showDelete:any) => {
  
  let iconState = params.value === 1 || params.value;

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const {resultError, exceptionError} = useNotifications();
  const { addToast } = useToasts();
	const [count,setCount] = useState(iconState);
	let notification: Notification;
  const api = new AdjuntosAdapter();
  let result:any;

  useEffect(()=>{
    if(count===0){
      params && params.setValue(false)
    }
  },[count])

  const isNoDeleteable = useMemo(() => {
    return params && (params.data.facturado === true || params.data.estado>1 || showDelete === false)
  },[params,showDelete])

  if (params.node.rowPinned) {
    return null;
  }

  const onDownLoadAdjuntos = async(idAdjunto: number, nombre: string) =>{
    try {
			result = await api.DescargarAdjunto(idAdjunto);
			if(result.data && result.data!=="")
			{
				await downloadFile(result.data,nombre)
			}else{resultError()}
		} catch (e) {
			let exception = ServerErrorMessage(e);
      exceptionError(exception);
		}
	}
	
	const onRemoveAdjuntos = async(data: any) =>{
    try {
			result = await api.EliminarAdjuntos(data);
			
			if(result.data && result.data!=="")
			{
        notification={type:"success",title:"Eliminar Adjunto(s)",message:(data.todosPartes ? "Se ha eliminado el adjunto para todos los partes." : "Se ha eliminado el adjunto para el parte.")}
				addToast(notification)
				return result.data;
			}else{resultError()}
		} catch (e) {
			let exception = ServerErrorMessage(e);
      exceptionError(exception)
		}
  }

  const onButtonClick = () =>{
    setIsPopoverOpen((isPopoverOpen) => !isPopoverOpen);
  }

  const closePopover = () => setIsPopoverOpen(false);

  const button = (
    <EuiButtonIcon
        onClick={onButtonClick}
        iconType={iconState ? "paperClip" : ""}
        iconSize="m"
        color="success"
        aria-label="adj"
      />
  );

  const handleRemoveAdjuntos = (idAdjunto:number,todos:boolean)=>{
    const dataRemove ={idParte: params.data.idParte, idAdjunto: idAdjunto, todosPartes: false}
    return onRemoveAdjuntos && onRemoveAdjuntos(dataRemove);
  }

  

  return (
    <EuiFlexItem>
      {iconState ?
        <EuiPopover
          className="popoverCell"
          ownFocus
          button={button}
          isOpen={isPopoverOpen}
          closePopover={closePopover}>
            <ListadoAdjuntos
            style={{maxHeight:"250px", width:"100%!important", maxWidth:"100%", overflowY:"auto"}}
            fullWidth
            idParte={params && params.data.idParte}
            handleDownload={onDownLoadAdjuntos}
            handleRemove={ isNoDeleteable ? undefined : handleRemoveAdjuntos}
            getNumberAdjuntos={setCount}
            onlyConfirm
            />
        </EuiPopover>
      :""}
    </EuiFlexItem>
  );
};